import type { EmailTemplateFormValues } from './EmailTemplates.types.ts';

export const getEmailTemplateValues = (
  data: EmailTemplateFormValues & {
    templateId: string;
    toAddress: string;
    fromAddress: string;
    bodyTemplate: string;
    isBodyHtml: boolean;
  },
) => ({
  id: data?.id || null,
  title: data?.templateId || '',
  subject: data?.subject || '',
  to: data?.toAddress || '',
  from: data?.fromAddress || '',
  body: data?.bodyTemplate || '',
  isHtml: data?.isBodyHtml || true,
});

export const getEmailTemplateData = (values: EmailTemplateFormValues) => ({
  templateId: values.title,
  subject: values.subject,
  toAddress: values.to,
  fromAddress: values.from,
  bodyTemplate: values.body,
  isBodyHtml: values.isHtml,
});